module.exports = __webpack_public_path__ + "img/smartphone2.7534b89c.png";